import { Organization, Policy, ResponseDataError, User } from 'src/types'

export enum MeActionTypes {
  ACCEPT_UPDATED_TERMS = '@me/ACCEPT_UPDATE_TERMS',
  CHANGE_PASSWORD = '@me/CHANGE_PASSWORD',
  CHANGE_PASSWORD_FAILURE = '@me/CHANGE_PASSWORD_FAILURE',
  CHANGE_PASSWORD_SUCCESS = '@me/CHANGE_PASSWORD_SUCCESS',
  GENERATE_QRCODE = '@me/GENERATE_QRCODE',
  GENERATE_QRCODE_FAILURE = '@me/GENERATE_QRCODE_FAILURE',
  GENERATE_QRCODE_SUCCESS = '@me/GENERATE_QRCODE_SUCCESS',
  GET_ME = '@me/GET_ME',
  GET_ME_FAILURE = '@me/GET_ME_FAILURE',
  GET_ME_SUCCESS = '@me/GET_ME_SUCCESS',
  GET_ORGANIZATION = '@me/GET_ORGANIZATION',
  GET_ORGANIZATION_FAILURE = '@me/GET_ORGANIZATION_FAILURE',
  GET_ORGANIZATION_SUCCESS = '@me/GET_ORGANIZATION_SUCCESS',
  GET_POLICY = '@me/GET_POLICY',
  GET_POLICY_FAILURE = '@me/GET_POLICY_FAILURE',
  GET_POLICY_SUCCESS = '@me/GET_POLICY_SUCCESS'
}

interface ErrorState {
  readonly changePassword?: boolean
  readonly organization?: boolean
  readonly policy?: boolean
  readonly qrCode?: boolean
  readonly user?: boolean
}

interface LoadingState {
  readonly changePassword?: boolean
  readonly organization?: boolean
  readonly policy?: boolean
  readonly qrCode?: boolean
  readonly user?: boolean
}

export type ResponseDataChangePassword = ResponseDataError & { status: boolean }

export type ResponseDataMe = ResponseDataError & { user: User }

export type ResponseDataOrganization = ResponseDataError & {
  organization: Organization
}

export type ResponseDataPolicies = ResponseDataError & { policies: Policy[] }

export type ResponseDataQrCode = ResponseDataError & { qrCode: string }

export interface MeState {
  readonly error: ErrorState
  readonly loading: LoadingState
  readonly organization: Organization | null
  readonly policy: Policy | null
  readonly qrCode: string
  readonly user: User | null
}
